<div class="login_wrapper">
    <img src="/assets/images/logo-mark.svg" class="login_logo" alt="" />
    <div class="login_content">
        <div class="login_box">
            <div class="login_box_inner">
                <img src="/assets/images/logo.svg" class="login_logo" alt="" />
                <p class="welcome_text_login">Reset Password</p>
                <p class="welcome_sub_text_login">
                    Enter your email to reset your password.
                </p>
                <hr style="border-color: #2a3238" />
                <form [formGroup]="loginForm">
                    <div class="login_control mb_24">
                        <p class="login_password_label">Email</p>
                        <input
                            type="email"
                            class="form-control login_form_control"
                            formControlName="email"
                            placeholder="Enter your Email"
                        />
                    </div>
                    <div
                        *ngIf="
                            loginForm.get('email')?.invalid &&
                            loginForm.get('email')?.touched
                        "
                        class="text-danger"
                    >
                        Enter a valid email address.
                    </div>
                </form>

                <!-- Success message -->
                <div
                    *ngIf="message && !isError"
                    class="alert alert-success mt-3"
                >
                    {{ message }}
                </div>

                <!-- Error message -->
                <div *ngIf="isError && message" class="alert alert-danger mt-3">
                    {{ message }}
                </div>

                <div *ngIf="isFormSubmitting">
                    <button class="btn login_button" type="submit">
                        <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                        ></span>
                        Loading...
                    </button>
                </div>
                <button
                    class="btn continue_login_btn_forgot"
                    type="submit"
                    *ngIf="!isFormSubmitting"
                    (click)="forgetPassword()"
                >
                    Reset Password
                </button>
            </div>
        </div>
    </div>
</div>
